var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgInsurance(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 35,
    viewBox: "0 0 24 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.359 35H1.4034C0.628225 35 0 34.3717 0 33.5966V3.50789C0 2.73272 0.628225 2.10449 1.4034 2.10449H21.359C22.1342 2.10449 22.7624 2.73272 22.7624 3.50789V33.5971C22.7619 34.3723 22.1336 35 21.359 35Z",
    fill: "#181C3F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.8267 35H1.87105C1.09588 35 0.467651 34.3717 0.467651 33.5966V3.50789C0.467651 2.73272 1.09588 2.10449 1.87105 2.10449H21.8267C22.6019 2.10449 23.2301 2.73272 23.2301 3.50789V33.5971C23.2295 34.3723 22.6019 35 21.8267 35Z",
    fill: "#27374A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22 34L22 3L1 3L1 34H22Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.05126 4.703L16.0032 4.703V1.63706L6.05126 1.63706V4.703Z",
    fill: "#6A93C7"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M9.16931 0V1.63691H13.5088V0H9.16931ZM9.74742 0.311549H12.9307V1.40282H9.74742V0.311549Z",
    fill: "#5C80AD"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M8.85718 0V1.63691H13.1967V0H8.85718ZM9.43528 0.311549H12.6185V1.40282H9.43528V0.311549Z",
    fill: "#6A93C7"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M16.4187 1.63696H17.1494V1.99749V2.10628H16.802V1.99749H16.4187V4.7029H16.0029V1.63696H16.4187Z",
    fill: "#5C80AD"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M6.7914 16.0485H3.51758V19.3223H6.7914V16.0485Z",
    fill: "#CACACA"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M3.92371 17.3312L5.07991 18.5523L7.89923 14.6941L5.06397 17.9514L3.92371 17.3312Z",
    fill: "#E96666"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M6.7914 21.583H3.51758V24.8568H6.7914V21.583Z",
    fill: "#CACACA"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M3.92371 22.8656L5.07991 24.0873L7.89923 20.2285L5.06397 23.4864L3.92371 22.8656Z",
    fill: "#E96666"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M6.7914 27.1173H3.51758V30.3911H6.7914V27.1173Z",
    fill: "#CACACA"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M3.92371 28.4006L5.07991 29.6217L7.89923 25.7629L5.06397 29.0208L3.92371 28.4006Z",
    fill: "#E96666"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5763 16.0707H7.79553V16.5901H11.5763V16.0707Z",
    fill: "#CACACA"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M20.6317 17.24H7.79553V17.7594H20.6317V17.24Z",
    fill: "#CACACA"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M20.6317 18.4873H7.79553V19.0067H20.6317V18.4873Z",
    fill: "#CACACA"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M17.4097 21.6057H7.79553V22.1252H17.4097V21.6057Z",
    fill: "#CACACA"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M20.6317 22.775H7.79553V23.2945H20.6317V22.775Z",
    fill: "#CACACA"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0711 24.0223H7.79553V24.5418H15.0711V24.0223Z",
    fill: "#CACACA"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1341 27.1401H7.79553V27.6596H10.1341V27.1401Z",
    fill: "#CACACA"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M20.6317 28.3093H7.79553V28.8288H20.6317V28.3093Z",
    fill: "#CACACA"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M20.6311 29.5568H13.3556V30.0762H20.6311V29.5568Z",
    fill: "#CACACA"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0865 7.05067C15.0865 7.05067 13.6371 5.98779 11.84 5.98779C10.0429 5.98779 8.59351 7.05067 8.59351 7.05067C8.59351 9.13775 8.57417 12.4025 11.84 13.5232C15.1058 12.4025 15.0865 9.13775 15.0865 7.05067Z",
    fill: "#0081AF"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M11.84 13.154C10.581 12.6902 9.75899 11.8406 9.32909 10.5598C8.95978 9.45993 8.94226 8.24195 8.94153 7.23636C9.09298 7.14002 9.35811 6.98364 9.70261 6.82891C10.2033 6.60392 10.9806 6.33569 11.84 6.33569C13.1931 6.33569 14.3472 6.98729 14.7386 7.23618C14.7378 8.24176 14.7203 9.45993 14.351 10.5598C13.9211 11.8406 13.0991 12.6902 11.84 13.154Z",
    fill: "#0099C9"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4326 7.43872H11.2473V11.5357H12.4326V7.43872Z",
    fill: "white"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M13.8884 10.0798V8.89453H9.79145V10.0798H13.8884Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInsurance);
export default __webpack_public_path__ + "static/media/insurance.c2faf1e54d498c5c898a350e5f3878e1.svg";
export { ForwardRef as ReactComponent };